<template>
    <b-modal
        body-class="p-0"
        cancel-disabled
        hide-footer
        id="email-modal"
        ok-disabled
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <div class="contact-us contact-details">
                <h3>Email us on:</h3>
                <h1><a :href="`mailto:${carrierDetails.email}`" class="text-primary font-weight-bold text-decoration-none">{{ carrierDetails.email }}</a></h1>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "PhoneModal",

    props: ['carrierDetails']
}
</script>

<style scoped>

</style>